/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Location_DescInputs */

const en_home_trust_location_desc = /** @type {(inputs: Home_Trust_Location_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canadian case managers`)
};

const fr_home_trust_location_desc = /** @type {(inputs: Home_Trust_Location_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaires de dossiers canadiens`)
};

/**
* | output |
* | --- |
* | "Canadian case managers" |
*
* @param {Home_Trust_Location_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_location_desc = /** @type {((inputs?: Home_Trust_Location_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Location_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_location_desc(inputs)
	return fr_home_trust_location_desc(inputs)
});